import { initReactI18next } from 'react-i18next'
import i18n, { initI18n } from './index'

if (!i18n.isInitialized) {
  i18n.use(initReactI18next)
}

void initI18n()

export default i18n
